module.exports = __webpack_public_path__ + "static/texture-flowers-f11784bcd1a635d3dc308aa9880ad6a6.png";